import { render, staticRenderFns } from "./CommunityList.vue?vue&type=template&id=90044db2&"
import script from "./CommunityList.vue?vue&type=script&lang=js&"
export * from "./CommunityList.vue?vue&type=script&lang=js&"
import style0 from "./CommunityList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports